var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareerDesignLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_10599_23857)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 12,
    fill: "url(#paint0_linear_10599_23857)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 12,
    fill: "url(#paint1_linear_10599_23857)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10599_23857",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 12,
    fill: "#5448A9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10599_23857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41684 57.0218C6.41684 56.7622 6.18888 56.5518 5.90764 56.5518C5.62639 56.5518 5.39844 56.7622 5.39844 57.0218C5.39844 57.2814 5.62639 57.4917 5.90764 57.4917C6.18888 57.4917 6.41684 57.2814 6.41684 57.0218ZM6.41684 54.2112C6.41684 53.9517 6.18888 53.7411 5.90764 53.7411C5.62639 53.7411 5.39844 53.9517 5.39844 54.2112C5.39844 54.4708 5.62639 54.681 5.90764 54.681C6.18888 54.681 6.41684 54.4708 6.41684 54.2112ZM6.41684 51.4005C6.41684 51.1411 6.18888 50.9307 5.90764 50.9307C5.62639 50.9307 5.39844 51.1411 5.39844 51.4005C5.39844 51.6602 5.62639 51.8704 5.90764 51.8704C6.18888 51.8704 6.41684 51.6602 6.41684 51.4005ZM6.41684 48.5899C6.41684 48.3304 6.18888 48.12 5.90764 48.12C5.62639 48.12 5.39844 48.3304 5.39844 48.5899C5.39844 48.8495 5.62639 49.0601 5.90764 49.0601C6.18888 49.0601 6.41684 48.8495 6.41684 48.5899ZM6.41684 45.7793C6.41684 45.5198 6.18888 45.3094 5.90764 45.3094C5.62639 45.3094 5.39844 45.5198 5.39844 45.7793C5.39844 46.0389 5.62639 46.2495 5.90764 46.2495C6.18888 46.2495 6.41684 46.0389 6.41684 45.7793ZM9.46224 57.0218C9.46224 56.7622 9.23428 56.5518 8.95304 56.5518C8.6718 56.5518 8.44377 56.7622 8.44377 57.0218C8.44377 57.2814 8.6718 57.4917 8.95304 57.4917C9.23428 57.4917 9.46224 57.2814 9.46224 57.0218ZM9.46224 54.2112C9.46224 53.9517 9.23428 53.7411 8.95304 53.7411C8.6718 53.7411 8.44377 53.9517 8.44377 54.2112C8.44377 54.4708 8.6718 54.681 8.95304 54.681C9.23428 54.681 9.46224 54.4708 9.46224 54.2112ZM9.46224 51.4005C9.46224 51.1411 9.23428 50.9307 8.95304 50.9307C8.6718 50.9307 8.44377 51.1411 8.44377 51.4005C8.44377 51.6602 8.6718 51.8704 8.95304 51.8704C9.23428 51.8704 9.46224 51.6602 9.46224 51.4005ZM9.46224 48.5899C9.46224 48.3304 9.23428 48.12 8.95304 48.12C8.6718 48.12 8.44377 48.3304 8.44377 48.5899C8.44377 48.8495 8.6718 49.0601 8.95304 49.0601C9.23428 49.0601 9.46224 48.8495 9.46224 48.5899ZM9.46224 45.7793C9.46224 45.5198 9.23428 45.3094 8.95304 45.3094C8.6718 45.3094 8.44377 45.5198 8.44377 45.7793C8.44377 46.0389 8.6718 46.2495 8.95304 46.2495C9.23428 46.2495 9.46224 46.0389 9.46224 45.7793ZM12.5076 57.0218C12.5076 56.7622 12.2797 56.5518 11.9984 56.5518C11.7171 56.5518 11.4892 56.7622 11.4892 57.0218C11.4892 57.2814 11.7171 57.4917 11.9984 57.4917C12.2797 57.4917 12.5076 57.2814 12.5076 57.0218ZM12.5076 54.2112C12.5076 53.9517 12.2797 53.7411 11.9984 53.7411C11.7171 53.7411 11.4892 53.9517 11.4892 54.2112C11.4892 54.4708 11.7171 54.681 11.9984 54.681C12.2797 54.681 12.5076 54.4708 12.5076 54.2112ZM12.5076 51.4005C12.5076 51.1411 12.2797 50.9307 11.9984 50.9307C11.7171 50.9307 11.4892 51.1411 11.4892 51.4005C11.4892 51.6602 11.7171 51.8704 11.9984 51.8704C12.2797 51.8704 12.5076 51.6602 12.5076 51.4005ZM12.5076 48.5899C12.5076 48.3304 12.2797 48.12 11.9984 48.12C11.7171 48.12 11.4892 48.3304 11.4892 48.5899C11.4892 48.8495 11.7171 49.0601 11.9984 49.0601C12.2797 49.0601 12.5076 48.8495 12.5076 48.5899ZM12.5076 45.7793C12.5076 45.5198 12.2797 45.3094 11.9984 45.3094C11.7171 45.3094 11.4892 45.5198 11.4892 45.7793C11.4892 46.0389 11.7171 46.2495 11.9984 46.2495C12.2797 46.2495 12.5076 46.0389 12.5076 45.7793ZM15.553 57.0218C15.553 56.7622 15.3251 56.5518 15.0438 56.5518C14.7625 56.5518 14.5346 56.7622 14.5346 57.0218C14.5346 57.2814 14.7625 57.4917 15.0438 57.4917C15.3251 57.4917 15.553 57.2814 15.553 57.0218ZM15.553 54.2112C15.553 53.9517 15.3251 53.7411 15.0438 53.7411C14.7625 53.7411 14.5346 53.9517 14.5346 54.2112C14.5346 54.4708 14.7625 54.681 15.0438 54.681C15.3251 54.681 15.553 54.4708 15.553 54.2112ZM15.553 51.4005C15.553 51.1411 15.3251 50.9307 15.0438 50.9307C14.7625 50.9307 14.5346 51.1411 14.5346 51.4005C14.5346 51.6602 14.7625 51.8704 15.0438 51.8704C15.3251 51.8704 15.553 51.6602 15.553 51.4005ZM15.553 48.5899C15.553 48.3304 15.3251 48.12 15.0438 48.12C14.7625 48.12 14.5346 48.3304 14.5346 48.5899C14.5346 48.8495 14.7625 49.0601 15.0438 49.0601C15.3251 49.0601 15.553 48.8495 15.553 48.5899ZM15.553 45.7793C15.553 45.5198 15.3251 45.3094 15.0438 45.3094C14.7625 45.3094 14.5346 45.5198 14.5346 45.7793C14.5346 46.0389 14.7625 46.2495 15.0438 46.2495C15.3251 46.2495 15.553 46.0389 15.553 45.7793ZM18.5984 57.0218C18.5984 56.7622 18.3703 56.5518 18.0892 56.5518C17.8079 56.5518 17.58 56.7622 17.58 57.0218C17.58 57.2814 17.8079 57.4917 18.0892 57.4917C18.3703 57.4917 18.5984 57.2814 18.5984 57.0218ZM18.5984 54.2112C18.5984 53.9517 18.3703 53.7411 18.0892 53.7411C17.8079 53.7411 17.58 53.9517 17.58 54.2112C17.58 54.4708 17.8079 54.681 18.0892 54.681C18.3703 54.681 18.5984 54.4708 18.5984 54.2112ZM18.5984 51.4005C18.5984 51.1411 18.3703 50.9307 18.0892 50.9307C17.8079 50.9307 17.58 51.1411 17.58 51.4005C17.58 51.6602 17.8079 51.8704 18.0892 51.8704C18.3703 51.8704 18.5984 51.6602 18.5984 51.4005ZM18.5984 48.5899C18.5984 48.3304 18.3703 48.12 18.0892 48.12C17.8079 48.12 17.58 48.3304 17.58 48.5899C17.58 48.8495 17.8079 49.0601 18.0892 49.0601C18.3703 49.0601 18.5984 48.8495 18.5984 48.5899ZM18.0892 46.2495C17.8079 46.2495 17.58 46.0389 17.58 45.7793C17.58 45.5198 17.8079 45.3094 18.0892 45.3094C18.3703 45.3094 18.5984 45.5198 18.5984 45.7793C18.5984 46.0389 18.3703 46.2495 18.0892 46.2495Z",
    fill: "#F9B050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.529449 27.906L11.4 39.4399C8.10576 42.6248 2.76479 42.6248 -0.529449 39.4399C-3.82352 36.2549 -3.82352 31.0909 -0.529449 27.906Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4 -3.71052L56.4706 7.34277C53.1765 4.29044 53.1765 -0.658339 56.4706 -3.71052C59.7648 -6.76285 65.1058 -6.76285 68.4 -3.71052Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.35573 10.8171L4.92172 0.55986C7.85132 2.50288 8.5971 6.37409 6.58747 9.20653C4.57786 12.039 0.57387 12.7601 -2.35573 10.8171Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1504 48.4863C59.5422 48.6452 59.9418 48.78 60.347 48.8911L73.4025 36.2686C73.2874 35.8768 73.1479 35.4905 72.9836 35.1115L59.1504 48.4863Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4609 47.62C57.7936 47.8306 58.1366 48.0195 58.4868 48.1899L72.6776 34.4698C72.5012 34.1314 72.3059 33.7997 72.0881 33.4777L57.4609 47.62Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0156 46.5175C56.2973 46.7731 56.5899 47.0118 56.892 47.2319L71.6867 32.9277C71.4589 32.6354 71.2123 32.3528 70.9477 32.0802L56.0156 46.5175Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8262 29.394C58.3426 29.8819 56.9488 30.6961 55.7661 31.8399C54.5831 32.9834 53.7412 34.3312 53.2363 35.7651L59.8262 29.394Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.127 49.0748C61.5985 49.1672 62.0748 49.2275 62.5535 49.2573L73.7807 38.4023C73.7497 37.9397 73.6873 37.479 73.5917 37.0233L61.127 49.0748Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8008 43.6588C53.9772 43.9974 54.1724 44.3291 54.3902 44.6509L69.0174 30.5086C68.6848 30.298 68.3417 30.1092 67.9916 29.9387L53.8008 43.6588Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8793 37.0496C52.7592 37.6295 52.6931 38.2172 52.6777 38.8062L62.9714 28.8537C62.3622 28.8684 61.7544 28.9325 61.1546 29.0486L52.8793 37.0496Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0742 41.8599C53.1893 42.2519 53.3288 42.6381 53.4929 43.0171L67.3263 29.6424C66.9345 29.4836 66.5349 29.3485 66.1297 29.2374L53.0742 41.8599Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6953 39.7264C52.7263 40.1888 52.7885 40.6496 52.8843 41.1055L65.349 29.0539C64.8775 28.9615 64.401 28.9012 63.9225 28.8712L52.6953 39.7264Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.791 45.2008C55.0188 45.4931 55.2654 45.7757 55.5297 46.0483L70.462 31.611C70.1801 31.3554 69.888 31.117 69.5857 30.8968L54.791 45.2008Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4 18.6245L49.8 22.1052H57L53.4 18.6245Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.103564 23.8953L-1.20312 24.9189H0.995834L-0.103564 23.8953Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23433 23.8953L2.13477 24.9189H4.33372L3.23433 23.8953Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57417 23.8953L5.47461 24.9189H7.67357L6.57417 23.8953Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83199 23.8953L8.73242 24.9189H10.9314L9.83199 23.8953Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.103564 20.588L-1.20312 21.6904H0.995834L-0.103564 20.588Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23433 20.588L2.13477 21.6904H4.33372L3.23433 20.588Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57417 20.588L5.47461 21.6904H7.67357L6.57417 20.588Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.103564 17.2809L-1.20312 18.3833H0.995834L-0.103564 17.2809Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23433 17.2809L2.13477 18.3833H4.33372L3.23433 17.2809Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52534 22.1627L0.425781 23.2651H2.62474L1.52534 22.1627Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86324 22.1627L3.76367 23.2651H5.96263L4.86324 22.1627Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16177 22.1627L7.02148 23.2651H9.30189L8.16177 22.1627Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52534 18.9342L0.425781 20.0366H2.62474L1.52534 18.9342Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86324 18.9342L3.76367 20.0366H5.96263L4.86324 18.9342Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2378 0.547363L46.3411 -0.519313H44.1348L45.2378 0.547363Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9312 0.547363L43.0343 -0.519313H40.8281L41.9312 0.547363Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6246 0.547363L39.7278 -0.519313H37.5215L38.6246 0.547363Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.316 0.547363L36.4192 -0.519313H34.2129L35.316 0.547363Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0093 0.547363L33.1124 -0.519313H30.9062L32.0093 0.547363Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7027 0.547363L29.8059 -0.519313H27.5996L28.7027 0.547363Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9312 3.8125L43.0343 2.74599H40.8281L41.9312 3.8125Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6246 3.8125L39.7278 2.74599H37.5215L38.6246 3.8125Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.316 3.8125L36.4192 2.74599H34.2129L35.316 3.8125Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0093 3.8125L33.1124 2.74599H30.9062L32.0093 3.8125Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6246 7.07764L39.7278 6.01096H37.5215L38.6246 7.07764Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.316 7.07764L36.4192 6.01096H34.2129L35.316 7.07764Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5836 2.27295L44.6868 1.20627H42.4805L43.5836 2.27295Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2769 2.27295L41.3802 1.20627H39.1738L40.2769 2.27295Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9703 2.27295L38.0734 1.20627H35.8672L36.9703 2.27295Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6636 2.27295L34.7669 1.20627H32.5605L33.6636 2.27295Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.357 2.27295L31.4601 1.20627H29.2539L30.357 2.27295Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2769 5.44482L41.3802 4.3783H39.1738L40.2769 5.44482Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9703 5.44482L38.0734 4.3783H35.8672L36.9703 5.44482Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6636 5.44482L34.7669 4.3783H32.5605L33.6636 5.44482Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9703 8.82275L38.0734 7.75608H35.8672L36.9703 8.82275Z",
    fill: "#FFD530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.498 57.5415H53.0581L51.498 56.0333V57.5415Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1602 55.2808H50.7201L49.1602 53.7724V55.2808Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8203 53.02H48.3803L46.8203 51.5116V53.02Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4824 50.7593H46.0426L44.4824 49.2509V50.7593Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1445 48.4985H43.7046L42.1445 46.9901V48.4985Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8066 46.2373H41.3667L39.8066 44.7291V46.2373Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7715 57.5898H48.3316L46.7715 56.0815V57.5898Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4336 55.3291H45.9936L44.4336 53.8207V55.3291Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0957 53.0679H43.6558L42.0957 51.5595V53.0679Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7559 50.8071H41.3159L39.7559 49.2989V50.8071Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0449 57.6377H43.6049L42.0449 56.1293V57.6377Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.707 55.377H41.2672L39.707 53.8686V55.377Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0664 57.6318H50.6266L49.0664 56.1235V57.6318Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7285 55.3706H48.2885L46.7285 53.8622V55.3706Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3906 53.1099H45.9507L44.3907 51.6015L44.3906 53.1099Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0508 50.8491H43.6108L42.0508 49.3409V50.8491Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7129 48.5884H41.2729L39.7129 47.08V48.5884Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4082 57.6138H45.9683L44.4082 56.1054V57.6138Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0703 55.353H43.6304L42.0703 53.8448V55.353Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7324 53.0923H41.2925L39.7324 51.5839V53.0923Z",
    fill: "#EF60A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5996 57.7412H41.1597L39.5997 56.2328L39.5996 57.7412Z",
    fill: "#EF60A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_10599_23857",
    x: -0.242322,
    y: -0.242322,
    width: 62.4846,
    height: 62.4846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.242322,
    dy: 0.242322
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.121161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10599_23857"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.242322,
    dy: -0.242322
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.121161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_10599_23857",
    result: "effect2_innerShadow_10599_23857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10599_23857",
    x1: 31,
    y1: 0,
    x2: 31,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C81DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5448A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10599_23857",
    x1: 31,
    y1: 0,
    x2: 31,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerDesignLarge);
export default __webpack_public_path__ + "static/media/career-design-large.12d7e69be1c1ade886ab3c045f244993.svg";
export { ForwardRef as ReactComponent };